import type { ReactNode } from 'react';

interface NoticeCardProps {
  icon: ReactNode;
  title: string;
  description: string;
  children?: ReactNode;
}

export const NoticeCard = ({ icon, title, description, children }: NoticeCardProps) => (
  <div
    className="bg-[var(--color-surface-2)] rounded-lg p-8 text-center border border-[var(--color-line)]"
    role="alert"
  >
    <div className="w-24 h-24 bg-[var(--color-surface-3)] rounded-full flex items-center justify-center mx-auto mb-4">
      {icon}
    </div>
    <h3 className="text-xl font-semibold text-[var(--color-ink)] mb-2">{title}</h3>
    <p className="text-[var(--color-ink-soft)]">{description}</p>
    {children && <div className="mt-4">{children}</div>}
  </div>
);
